// German (DE) and Kurdish Kurmancî (KU) translations
export const translations = {
  de: {
    nav: {
      prices: "Preise",
      about: "Über uns",
      gallery: "Galerie",
      contact: "Kontakt",
      whatsapp: "WhatsApp",
      back_home: "Zurück zur Startseite",
    },
    hero: {
      sublabel: "Herren Friseur Salon · Hamburg",
      title_main: "YOUR CUT",
      tagline: "Reinkommen. Drankommen.",
      tagline_accent: "Ohne Termin.",
      description:
        "Klassischer Herren-Barbershop in Hamburg. Präzise Schnitte, Bartstyling und traditionelle Rasur – jeden Tag offen, ohne Termin.",
      cta_primary: "Per WhatsApp schreiben",
      cta_secondary: "Anfahrt ansehen",
      rating: "4,7 Sterne auf Google",
      walkin_badge: "Walk-In Barbershop",
    },
    pricing: {
      eyebrow: "Preisliste",
      title: "Klare Preise. Sauberes Handwerk.",
      subtitle:
        "Transparente Preise für jeden Service. Endgültige Preise können je nach Haarlänge oder besonderem Aufwand leicht abweichen.",
      note: "Hinweis: Bei aufwendigen Schnitten, langen Haaren oder Sonderwünschen kann der Endpreis abweichen. Sprich uns gerne vor Ort an.",
      items: [
        { name: "Herrenhaarschnitt", price: "17 €" },
        { name: "Kinderhaarschnitt (bis 8 Jahre)", price: "13 €" },
        { name: "Bart schneiden & konturieren", price: "13 €" },
        { name: "Haar + Bart Kombi", price: "30 €" },
        { name: "Klassische Rasur (Messer)", price: "13 €" },
        { name: "Augenbrauen zupfen", price: "5 – 7 €" },
        { name: "Waschen, Schneiden & Styling", price: "20 €" },
      ],
    },
    about: {
      eyebrow: "Über YOUR CUT",
      title: "Handwerk. Haltung. Hamburg.",
      p1: "YOUR CUT ist ein klassischer Herren-Barbershop am Hammer Steindamm. Wir setzen auf saubere Arbeit, ehrliche Beratung und einen ruhigen, respektvollen Umgang – ohne App, ohne Termin, ohne Stress.",
      p2: "Ob Fade, klassischer Haarschnitt, Konturen, Bartstyling oder traditionelle Nass­rasur mit der Klinge: Unser Team arbeitet präzise und nimmt sich die Zeit, die ein guter Schnitt braucht.",
      feature_1_title: "Ohne Termin",
      feature_1_text: "Reinkommen, kurz Platz nehmen – und du bist dran.",
      feature_2_title: "Erfahrenes Team",
      feature_2_text: "Barbiere mit Routine, Auge und Anspruch.",
      feature_3_title: "Mitten in Hamburg",
      feature_3_text: "Hammer Steindamm 62 – mit Bus und Bahn gut erreichbar.",
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Einblicke in den Salon",
      subtitle: "Schnitte, Styles und Atmosphäre bei YOUR CUT.",
    },
    contact: {
      eyebrow: "Kontakt & Anfahrt",
      title: "Komm vorbei.",
      subtitle: "Wir freuen uns auf dich – Walk-In jederzeit, oder schreib uns vorab kurz auf WhatsApp.",
      form_name: "Dein Name",
      form_email: "E-Mail",
      form_phone: "Telefon (optional)",
      form_message: "Deine Nachricht",
      form_submit: "Nachricht senden",
      form_sending: "Sende …",
      form_success: "Danke! Wir melden uns zeitnah bei dir.",
      form_error: "Nachricht konnte nicht gesendet werden. Bitte versuche es nochmal.",
      form_privacy:
        "Mit dem Absenden stimmst du der Verarbeitung deiner Angaben zur Bearbeitung deiner Anfrage zu. Details findest du in unserer",
      form_privacy_link: "Datenschutzerklärung",
      address_title: "Adresse",
      address: "Hammer Steindamm 62, 20535 Hamburg",
      phone_title: "Telefon",
      phone: "+49 163 7036972",
      email_title: "E-Mail",
      email: "hallo@yourcut-hamm.de",
      hours_title: "Öffnungszeiten",
      hours: [
        { day: "Täglich", time: "09:00 – 20:00 Uhr" },
      ],
    },
    footer: {
      tagline: "Herren Friseur Salon Hamburg",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
    whatsapp_float: "Auf WhatsApp schreiben",
    language_label: "Sprache",
    legal: {
      back: "Zurück",
      todo_label: "NOCH BEFÜLLEN",
      last_updated: "Stand",

      imprint: {
        title: "Impressum",
        intro: "Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz) und § 18 MStV.",
        section_provider: "Diensteanbieter",
        provider_name_label: "Name / Inhaber",
        provider_name_todo: "Vollständiger Name des Inhabers / Geschäftsführers",
        provider_legal_label: "Rechtsform",
        provider_legal_todo: "Rechtsform (z. B. Einzelunternehmen, GmbH, UG, GbR)",
        provider_address_label: "Anschrift",
        provider_address: "Hammer Steindamm 62, 20535 Hamburg, Deutschland",

        section_contact: "Kontakt",
        contact_phone_label: "Telefon",
        contact_phone: "+49 163 7036972",
        contact_email_label: "E-Mail",
        contact_email_todo: "Geschäftliche E-Mail-Adresse",

        section_tax: "Umsatzsteuer / Steuernummer",
        tax_todo:
          "USt-IdNr. gemäß § 27a UStG oder Steuernummer (eine Angabe genügt)",

        section_profession: "Berufsrechtliche Angaben",
        profession_label: "Berufsbezeichnung",
        profession_value: "Friseur (verliehen in der Bundesrepublik Deutschland)",
        chamber_label: "Zuständige Kammer",
        chamber_todo: "Zuständige Handwerkskammer (i. d. R. Handwerkskammer Hamburg)",
        guild_label: "Innung",
        guild_todo: "Mitgliedschaft in einer Friseur-Innung (falls zutreffend)",
        rules_label: "Berufsrechtliche Regelungen",
        rules_value:
          "Handwerksordnung (HwO) – einsehbar unter www.gesetze-im-internet.de/hwo",

        section_responsible: "Inhaltlich verantwortlich (§ 18 Abs. 2 MStV)",
        responsible_todo: "Vollständiger Name und Anschrift der inhaltlich verantwortlichen Person",

        section_eu: "EU-Streitschlichtung",
        eu_text:
          "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
        eu_link: "https://ec.europa.eu/consumers/odr",

        section_consumer: "Verbraucherstreitbeilegung",
        consumer_text:
          "Wir sind nicht bereit oder verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",

        section_liability: "Haftung für Inhalte",
        liability_text:
          "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",

        section_links: "Haftung für Links",
        links_text:
          "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",

        section_copyright: "Urheberrecht",
        copyright_text:
          "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
      },

      privacy: {
        title: "Datenschutz­erklärung",
        intro:
          "Wir nehmen den Schutz deiner persönlichen Daten ernst. Diese Erklärung informiert dich darüber, welche Daten beim Besuch dieser Website und bei der Kontaktaufnahme erhoben werden, wie sie verarbeitet werden und welche Rechte dir zustehen.",

        section_responsible: "1. Verantwortlicher",
        responsible_text:
          "Verantwortlich für die Datenverarbeitung auf dieser Website ist:",
        responsible_company: "YOUR CUT Herren Friseur Salon",
        responsible_address: "Hammer Steindamm 62, 20535 Hamburg",
        responsible_phone: "Telefon: +49 163 7036972",
        responsible_email_todo: "Kontakt-E-Mail des Verantwortlichen",
        responsible_name_todo: "Name des Inhabers / Verantwortlichen",

        section_hosting: "2. Hosting & Server-Logfiles",
        hosting_text:
          "Diese Website wird auf einem Webserver gehostet. Beim Aufruf werden technisch notwendige Daten in Server-Logfiles erfasst (IP-Adresse, Datum und Uhrzeit, aufgerufene Ressource, Browsertyp, Betriebssystem). Diese Daten werden ausschließlich zur Sicherstellung des Betriebs und zur Abwehr von Angriffen verarbeitet (Art. 6 Abs. 1 lit. f DSGVO) und nach kurzer Zeit gelöscht.",
        hosting_provider_label: "Hoster",
        hosting_provider_todo: "Name und Anschrift des Hosting-Anbieters (z. B. Alfahosting GmbH, Magdeburg)",

        section_form: "3. Kontaktformular",
        form_text:
          "Wenn du uns über das Kontaktformular eine Nachricht schickst, verarbeiten wir die von dir übermittelten Angaben (Name, E-Mail-Adresse, optional Telefonnummer und deine Nachricht) ausschließlich zur Bearbeitung deiner Anfrage. Die Daten werden in einer Datenbank (MongoDB) auf dem oben genannten Server gespeichert.",
        form_legal:
          "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines Vertragsverhältnisses) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der effizienten Bearbeitung von Kundenanfragen). Eine Weitergabe an Dritte findet nicht statt. Deine Anfrage wird gelöscht, sobald sie nicht mehr benötigt wird; gesetzliche Aufbewahrungsfristen bleiben unberührt.",

        section_whatsapp: "4. WhatsApp",
        whatsapp_text:
          "Auf unserer Website findest du Verlinkungen zu WhatsApp (Betreiber: WhatsApp Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland; Mutterkonzern: Meta Platforms, Inc., USA). Wenn du auf einen WhatsApp-Link klickst, wirst du zu WhatsApp weitergeleitet und es können Daten (z. B. deine Telefonnummer, dein Profil und der Inhalt deiner Nachricht) an WhatsApp bzw. Meta übertragen werden – ggf. auch in die USA. Auf diese Verarbeitung haben wir keinen Einfluss.",
        whatsapp_legal:
          "Die Nutzung erfolgt freiwillig auf Grundlage deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) durch den Klick auf den Link. Weitere Informationen findest du in der Datenschutzerklärung von WhatsApp/Meta: https://www.whatsapp.com/legal/privacy-policy-eea",

        section_maps: "5. Google Maps",
        maps_text:
          "Wir binden auf der Kontaktseite eine Karte des Dienstes Google Maps (Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland) ein, um dir die Anfahrt zu erleichtern. Beim Aufruf der Karte werden Informationen wie deine IP-Adresse und der besuchte Seitenpfad an Google übermittelt – ggf. auch in die USA.",
        maps_legal:
          "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer benutzerfreundlichen Darstellung des Standorts). Weitere Informationen findest du in der Datenschutzerklärung von Google: https://policies.google.com/privacy",

        section_fonts: "6. Google Fonts",
        fonts_text:
          "Diese Website verwendet Web-Fonts, die von Google bereitgestellt werden, um eine einheitliche Darstellung der Schriftarten zu ermöglichen. Beim Aufruf einer Seite lädt dein Browser die benötigten Web-Fonts in den Browser-Cache, wozu eine Verbindung zu Servern von Google aufgebaut wird. Dabei wird deine IP-Adresse an Google übermittelt. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.",

        section_rights: "7. Deine Rechte",
        rights_intro:
          "Dir stehen gegenüber dem Verantwortlichen folgende Rechte hinsichtlich deiner personenbezogenen Daten zu:",
        rights_list: [
          "Recht auf Auskunft (Art. 15 DSGVO)",
          "Recht auf Berichtigung (Art. 16 DSGVO)",
          "Recht auf Löschung (Art. 17 DSGVO)",
          "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
          "Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
          "Widerspruchsrecht (Art. 21 DSGVO)",
          "Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)",
        ],
        rights_authority:
          "Du hast außerdem das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig ist u. a. der Hamburgische Beauftragte für Datenschutz und Informationsfreiheit (https://datenschutz-hamburg.de).",

        section_languages: "8. Mehrsprachigkeit",
        languages_text:
          "Diese Website wird in deutscher und kurdischer Sprache (Kurmancî) bereitgestellt. Bei Abweichungen zwischen den Fassungen ist die deutsche Version maßgeblich.",

        section_changes: "9. Änderungen dieser Erklärung",
        changes_text:
          "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen abzubilden. Es gilt jeweils die zum Zeitpunkt deines Besuchs aktuelle Fassung.",
      },
    },
  },

  ku: {
    nav: {
      prices: "Bihayê",
      about: "Derbarê me",
      gallery: "Galerî",
      contact: "Têkilî",
      whatsapp: "WhatsApp",
      back_home: "Vegere serûpelê",
    },
    hero: {
      sublabel: "Salona Porxweşkirina Mêran · Hamburg",
      title_main: "YOUR CUT",
      tagline: "Were hundir. Nobeta te ye.",
      tagline_accent: "Bê randev.",
      description:
        "Barbershopek klasîk a mêran li Hamburgê. Porjêkirinên teqez, stîla rih û teraşkirina kevneşopî – her roj vekirî, bê randev.",
      cta_primary: "Bi WhatsApp binivîse",
      cta_secondary: "Adresê bibîne",
      rating: "4,7 stêrk li Google",
      walkin_badge: "Barbershop bê randev",
    },
    pricing: {
      eyebrow: "Lîsteya bihayê",
      title: "Bihayê zelal. Karê paqij.",
      subtitle:
        "Bihayê zelal ji bo her xizmetê. Bihayê dawî dibe ku li gor dirêjahiya por an karê taybet hinekî biguhere.",
      note: "Têbînî: Di porjêkirinên zehmet, porên dirêj an daxwazên taybet de, bihayê dawî dibe ku biguhere. Ji kerema xwe li ser cih bipirse.",
      items: [
        { name: "Porjêkirina mêran", price: "17 €" },
        { name: "Porjêkirina zarokan (heta 8 salî)", price: "13 €" },
        { name: "Rih jêkirin û şeklandin", price: "13 €" },
        { name: "Por + Rih bi hev re", price: "30 €" },
        { name: "Teraşkirina bi kêrê klasîk", price: "13 €" },
        { name: "Birû rast kirin", price: "5 – 7 €" },
        { name: "Şûştin, Jêkirin & Stîl", price: "20 €" },
      ],
    },
    about: {
      eyebrow: "Derbarê YOUR CUT",
      title: "Huner. Helwest. Hamburg.",
      p1: "YOUR CUT barbershopek klasîk a mêran e li Hammer Steindamm. Em li ser karê paqij, şîreta rast û rêzgirtinê dixebitin – bê app, bê randev, bê stres.",
      p2: "Çi Fade, çi porjêkirina klasîk, çi şeklandina rih an teraşkirina bi kêrê – tîma me bi teqezî dixebite û wextê ku porjêkirinek baş hewce dike jê re dide.",
      feature_1_title: "Bê randev",
      feature_1_text: "Were, demek kin rûne – û tu yê li kursiyê bî.",
      feature_2_title: "Tîmek pisporî",
      feature_2_text: "Barberên bi tecrûbe, çav û standardê bilind.",
      feature_3_title: "Li dilê Hamburgê",
      feature_3_text: "Hammer Steindamm 62 – bi otobûs û trênê tê gihîştin.",
    },
    gallery: {
      eyebrow: "Galerî",
      title: "Dîtinên ji salonê",
      subtitle: "Porjêkirin, stîl û hewaya YOUR CUT.",
    },
    contact: {
      eyebrow: "Têkilî & Adres",
      title: "Were serdana me.",
      subtitle: "Em li hêviya te ne – Walk-In her dem, an pêşî bi WhatsApp bişîne.",
      form_name: "Navê te",
      form_email: "E-Mail",
      form_phone: "Têlefon (ne mecbûrî)",
      form_message: "Mesaja te",
      form_submit: "Mesajê bişîne",
      form_sending: "Tê şandin …",
      form_success: "Spas! Em ê zû bi te re têkilî daynin.",
      form_error: "Mesaj neçû. Ji kerema xwe dîsa biceribîne.",
      form_privacy:
        "Bi şandinê, tu razî yî ku agahên te ji bo bersivdana daxwaza te bên xebitandin. Hûragahî di",
      form_privacy_link: "Daxuyaniya parastina daneyan",
      address_title: "Adres",
      address: "Hammer Steindamm 62, 20535 Hamburg",
      phone_title: "Têlefon",
      phone: "+49 163 7036972",
      email_title: "E-Mail",
      email: "hallo@yourcut-hamm.de",
      hours_title: "Saetên kar",
      hours: [
        { day: "Her roj", time: "09:00 – 20:00" },
      ],
    },
    footer: {
      tagline: "Salona Porxweşkirina Mêran Hamburg",
      rights: "Hemû maf parastî ne.",
      imprint: "Impressum",
      privacy: "Parastina Daneyan",
    },
    whatsapp_float: "Li WhatsApp binivîse",
    language_label: "Ziman",
    legal: {
      back: "Vegere",
      todo_label: "NOCH BEFÜLLEN",
      last_updated: "Roja nûjenkirinê",

      imprint: {
        title: "Impressum",
        intro: "Agahî li gorî § 5 DDG (Yasaya Karûbarên Dîjîtal) û § 18 MStV.",
        section_provider: "Pêşkêşkar",
        provider_name_label: "Nav / Xwedî",
        provider_name_todo: "Navê tam yê xwediyê / gerînendeyê karsaziyê",
        provider_legal_label: "Rewşa hiqûqî",
        provider_legal_todo: "Rewşa hiqûqî (mînak: Einzelunternehmen, GmbH, UG, GbR)",
        provider_address_label: "Navnîşan",
        provider_address: "Hammer Steindamm 62, 20535 Hamburg, Almanya",

        section_contact: "Têkilî",
        contact_phone_label: "Têlefon",
        contact_phone: "+49 163 7036972",
        contact_email_label: "E-Mail",
        contact_email_todo: "E-Maila karsaziyê",

        section_tax: "Bacê / Hejmara baca",
        tax_todo:
          "USt-IdNr. li gorî § 27a UStG an Steuernummer (yek bes e)",

        section_profession: "Agahiyên pîşeyî",
        profession_label: "Pîşe",
        profession_value: "Friseur (li Komara Federal a Almanyayê hatiye dayîn)",
        chamber_label: "Odeya berpirs",
        chamber_todo: "Odeya Karûbarên Destan ya berpirs (bi giştî Handwerkskammer Hamburg)",
        guild_label: "Innung",
        guild_todo: "Endamtî di Innunga Friseuran de (heke hebe)",
        rules_label: "Rêziknameyên pîşeyî",
        rules_value:
          "Handwerksordnung (HwO) – li www.gesetze-im-internet.de/hwo",

        section_responsible: "Berpirsê naverokê (§ 18 Abs. 2 MStV)",
        responsible_todo: "Navê tam û navnîşana kesê berpirsê naverokê",

        section_eu: "Çareseriya nakokiyan ya YE",
        eu_text:
          "Komîsyona Ewropî platformek ji bo çareseriya nakokiyan a serhevdanî (OS) peyda dike:",
        eu_link: "https://ec.europa.eu/consumers/odr",

        section_consumer: "Çareseriya nakokiyên xerîdaran",
        consumer_text:
          "Em ne amade ne û ne mecbûr in ku li ber dezgehek çareseriya nakokiyan a xerîdaran beşdar bibin.",

        section_liability: "Berpirsiyariya naverokê",
        liability_text:
          "Wek pêşkêşkar, em li gorî § 7 Abs. 1 DDG ji bo naveroka xwe ya van rûpelan li gorî yasayên giştî berpirsiyar in. Lê li gorî §§ 8 heta 10 DDG, em ne mecbûr in ku agahiyên ji aliyê kesên din ve hatine şandin an hilanîn temaşe bikin.",

        section_links: "Berpirsiyariya lînkan",
        links_text:
          "Pêşkêşa me lînkan vedigire ber bi malperên derveyî yên kesên din. Em nikarin garantî ji bo naveroka wan bidin. Ji bo naveroka rûpelên lînkkirî, her dem pêşkêşkar an gerînendeyê wan berpirsiyar e.",

        section_copyright: "Mafê telîfê",
        copyright_text:
          "Naverok û berhemên ku ji aliyê gerînendeyê malperê ve hatine afirandin di bin mafê telîfê yê Almanî de ne. Pirkirin, sererastkirin, belavkirin û her cure xebitandinê derveyî sînorên mafê telîfê pêwîstî bi razîbûna nivîskî heye.",
      },

      privacy: {
        title: "Daxuyaniya Parastina Daneyan",
        intro:
          "Em parastina daneyên te yên kesane bi giranî digirin. Ev daxuyanî te agahdar dike ka çi daneyên di dema serdana vê malperê û têkiliyê de tên berhevkirin, çawa tên xebitandin û çi mafên te hene.",

        section_responsible: "1. Berpirs",
        responsible_text:
          "Berpirsê xebitandina daneyan li ser vê malperê:",
        responsible_company: "YOUR CUT Salona Porxweşkirina Mêran",
        responsible_address: "Hammer Steindamm 62, 20535 Hamburg",
        responsible_phone: "Têlefon: +49 163 7036972",
        responsible_email_todo: "E-Maila têkiliyê ya berpirs",
        responsible_name_todo: "Navê xwedî / berpirs",

        section_hosting: "2. Hosting & Logfileyên Server",
        hosting_text:
          "Ev malper li ser servera webê tê hosting kirin. Di dema gazîkirinê de, daneyên teknîkî yên hewce di logfileyên server de tên tomarkirin (navnîşana IP, dîrok û saet, çavkaniya gazîkirî, cureyê browserê, sîstema xebitandinê). Ev dane tenê ji bo ewlehiya xebitandinê û dijî êrişan tên xebitandin (Art. 6 Abs. 1 lit. f DSGVO) û piştî demek kurt tên jêbirin.",
        hosting_provider_label: "Hoster",
        hosting_provider_todo: "Navê û navnîşana hosting-pêşkêşkar (mînak: Alfahosting GmbH, Magdeburg)",

        section_form: "3. Forma têkiliyê",
        form_text:
          "Heke tu bi forma têkiliyê mesajek bişînî, em agahiyên ku te şandine (nav, e-mail, vebijarkî hejmara têlefonê û mesaja te) tenê ji bo bersivdana daxwaza te dixebitînin. Dane di databasê de (MongoDB) li ser servera jor hatî behskirin tên hilanîn.",
        form_legal:
          "Bingeha hiqûqî Art. 6 Abs. 1 lit. b DSGVO (amadekirina pêwendiya peymanê) an Art. 6 Abs. 1 lit. f DSGVO (berjewendiya rewa) e. Veguhastina daneyan ji kesên din re nayê kirin. Daxwaza te tê jêbirin gava ku êdî hewce nebe; demên hilgirtina yasayî nayên guhertin.",

        section_whatsapp: "4. WhatsApp",
        whatsapp_text:
          "Li ser malpera me lînkên WhatsApp hene (xebatkar: WhatsApp Ireland Limited, Dublin; pargîdaniya dayik: Meta Platforms, Inc., DYA). Heke tu li ser lînka WhatsApp bitikînî, tu yê ber bi WhatsApp ve tê veguhastin û dane (mînak: hejmara te ya têlefonê, profîla te û naveroka mesaja te) dibe ku ji WhatsApp/Meta re bê veguhastin – dibe ku jî ber bi DYA ve. Em nikarin vê xebitandinê kontrol bikin.",
        whatsapp_legal:
          "Bikaranîn bi vebijarkî li gorî razîbûna te (Art. 6 Abs. 1 lit. a DSGVO) bi tikandina lînkê tê kirin. Hûragahî: https://www.whatsapp.com/legal/privacy-policy-eea",

        section_maps: "5. Google Maps",
        maps_text:
          "Em li ser rûpela têkiliyê nexşeyek ji Google Maps (pêşkêşkar: Google Ireland Limited, Dublin) vedikin da ku em adrese ji te re hêsantir bikin. Di dema vekirina nexşeyê de, agahiyên wek navnîşana IP û rêya rûpelê bo Google tê veguhastin – dibe ku jî bo DYA.",
        maps_legal:
          "Bingeha hiqûqî Art. 6 Abs. 1 lit. f DSGVO ye. Hûragahî: https://policies.google.com/privacy",

        section_fonts: "6. Google Fonts",
        fonts_text:
          "Ev malper Web-Fonts ên Google bikar tîne ji bo nîşandanek yekgirtî ya tîpan. Di dema vekirinê de, browser girêdanê bi serverên Google re datîne û navnîşana IP veguhêze. Bingeha hiqûqî: Art. 6 Abs. 1 lit. f DSGVO.",

        section_rights: "7. Mafên te",
        rights_intro:
          "Li hember berpirs, derbarê daneyên te yên kesane mafên te yên jêrîn hene:",
        rights_list: [
          "Mafê agahiyê (Art. 15 DSGVO)",
          "Mafê rastkirinê (Art. 16 DSGVO)",
          "Mafê jêbirinê (Art. 17 DSGVO)",
          "Mafê sînorkirina xebitandinê (Art. 18 DSGVO)",
          "Mafê veguhastina daneyan (Art. 20 DSGVO)",
          "Mafê dijwerkirinê (Art. 21 DSGVO)",
          "Mafê betalkirina razîbûnê (Art. 7 Abs. 3 DSGVO)",
        ],
        rights_authority:
          "Her wiha mafê te heye ku tu li ba desthilatdariya parastina daneyan gilî bikî, mînak: Hamburgischer Beauftragter für Datenschutz und Informationsfreiheit (https://datenschutz-hamburg.de).",

        section_languages: "8. Pirzimanî",
        languages_text:
          "Ev malper bi zimanê Almanî û Kurdî (Kurmancî) tê pêşkêşkirin. Di rewşa cudahiyê de, guhertoya Almanî baş tê hesibandin.",

        section_changes: "9. Guhertinên vê daxuyaniyê",
        changes_text:
          "Em mafê xwe diparêzin ku em vê daxuyaniyê biguherin da ku her dem li gorî hewcedariyên hiqûqî yên niha be. Guhertoya niha ya li dema serdana te derbasdar e.",
      },
    },
  },
};
